export class ResetPasswordModel {
    public password: string;
    public confirmPassword: string;
    // public captcha: string;
}
